export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE = 'delete_item'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SAVE_TO_PROFILE =
  'save_to_profile'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_ADDITIONAL_EMAIL =
  'send_additional_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EMAIL =
  'send_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EPOST =
  'send_epost'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE = 'delete'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE =
  'activate_save_to_profile'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE =
  'deactivate_save_to_profile'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL =
  'activate_send_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL =
  'deactivate_send_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL =
  'activate_send_additional_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL =
  'deactivate_send_additional_email'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EPOST =
  'activate_send_epost'

export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EPOST =
  'deactivate_send_epost'

// includes several mass actions
export const DOC_FLOW_SENDING_COMMUNICATION_TABLE_COMPOSITE_MASS_ACTION =
  'multi_mass_action'
